import { FC, Key, PropsWithChildren, ComponentProps } from 'react';

import classNames from 'classnames';
import { IonItem, IonCheckbox } from '@ionic/react';
import { useContextSelector } from 'use-context-selector';

import { FormCheckboxGroupContext } from '../FormCheckboxGroup.context';

import { FormCheckboxGroupItemInset } from './FormCheckboxGroupItem.types';

import group from '../../_styles/group.module.scss';

type FormCheckboxGroupItemProps = PropsWithChildren<{
  value: Key;
  className?: string;
  inset?: FormCheckboxGroupItemInset;
}>;

export const FormCheckboxGroupItem: FC<FormCheckboxGroupItemProps> = ({
  value,
  children,
  inset = 'md',
}) => {
  const values = useContextSelector(
    FormCheckboxGroupContext,
    ({ values }) => values
  );

  const onChange = useContextSelector(
    FormCheckboxGroupContext,
    ({ onChange }) => onChange
  );

  const handleOnChange: ComponentProps<typeof IonCheckbox>['onIonChange'] = ({
    detail: { checked, value },
  }) => {
    if (checked) {
      onChange([...values, value]);
    } else {
      onChange(values.filter((v) => v !== value));
    }
  };

  return (
    <IonItem lines="full" className={classNames(group.item, group[inset])}>
      <IonCheckbox
        value={value}
        justify="start"
        labelPlacement="end"
        className={group.control}
        onIonChange={handleOnChange}
        checked={values.includes(value)}
      >
        <div className={classNames(group.content)}>{children}&nbsp;</div>
      </IonCheckbox>
    </IonItem>
  );
};
